<template>
  <div class="swiper_item_long_pic">
    <img src="https://img.winbaoxian.com/autoUpload/common/e241e154-0e4d-46af-9285-98c0f7009ee1.png" alt="长图模板">
  </div>
</template>
<script>
import { get as _get } from 'lodash'
export default {
  props: {
    resultData: {
      type: Object,
      default: () => ({})
    },
    isShowBusinessCard: Boolean,
    cardImageData: String
  }
}
</script>
<style>
.swiper_item_long_pic {
  margin: 0 auto;
  text-align: center;
  & img {
    display: inline-block;
    width: 240px;
  }
}
</style>